import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { URLS } from '../urls';
// import '../../assets/css/style.css';

import { updateUser } from '../api/ApiAction';

export class Login extends React.Component {
    state = {
        user:{
            email : '',
            password : ''
        }

    };
    updateUserEmail = (event) => {
        const { user } = this.state;
        user.email = event.target.value;
        this.setState({
            user
        });
    };
    updateUserPassword = (event) => {
        const { user } = this.state;
        user.password = event.target.value;
        this.setState({
            user
        });
    };

    showErrors = (error) => { // make object, key value pair 
        if (error.code === 'auth/invalid-email') {
            this.setState({ emailError: 'Email address is badly formatted' });
        } else if (error.code === 'auth/user-not-found') {
            this.setState({ emailError: 'Email address not found' });
        } else if (error.code === 'auth/wrong-password') {
            this.setState({ passError: 'Incorrect password' });
        } else {
            console.log('HANDLE ERROR CODE', error);
        }
    };

    signIn = (e) => {
        e && e.preventDefault && e.preventDefault();
        // const email = this.refs.email.value;
        // const pass = this.refs.pass.value;
        const {user} = this.state;
        this.setState({ buttonText: 'Signing in...', isWaiting: true })
        fetch(URLS.backendUsers + '/signIn', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: user.email, password : user.password }),
        })
            .then((response) => {
                if (response.ok) {
                    response.json().then((responseJson) => {
                        localStorage.setItem('isLoggedIn', true);
                        localStorage.setItem('userId',responseJson.user._id)
                        localStorage.setItem('user', responseJson.user.username);
                        if(responseJson.user.isAdmin){
                            localStorage.setItem('isAdmin', true);
                            this.props.history.push(URLS.dashboard);
                        }else{
                            localStorage.setItem('isAdmin', false);
                            this.props.history.push(URLS.userDashboardProfile);
                        }
                        
                        
                        // localStorage.setItem('token', responseJson.token);
                        // localStorage.setItem('isLoggedIn', true);
                        // if (window.location.pathname === URLS.landingPage) this.props.history.push(URLS.dashboard);
                        // this.props.updateUser({
                        //     userData: responseJson.user,
                        //     topics: responseJson.topics,
                        //     difficulty: responseJson.difficulty,
                        //     feeds: responseJson.feeds,
                        //     leaderboard: responseJson.leaderboard,
                        //     completedAssessments: responseJson.completedAssessments,
                        //     assessments: responseJson.assessments,
                        // });
                    });
                } else {
                    // response.json().then((responseJson) => {
                    //     this.showErrors(responseJson.error);
                    // });
                }
                this.setState({ buttonText: 'SIGN IN', isWaiting: false });
            })
            .catch(error => {
                this.setState({ buttonText: 'SIGN IN', isWaiting: false })
            });
    };
    signInTemp = () =>{
        this.props.history.push(URLS.dashboard);
    }

    removeEmailError = () => this.setState({ emailError: '' })

    removePassError = text => this.setState({ passError: '', password: text.target.value })

    showPass = () => this.setState({ showPass: true })

    hidePass = () => this.setState({ showPass: false })

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.signIn();
        }
    };

    render() {
        const {user} = this.state;
        return (
            <div className='account-box'>
                <div className='account-wrapper'>
                    <h3 className='account-title'>Login</h3>
                    <p className='account-subtitle'>Access to our dashboard</p> 
                    {/*<form action='dashboard'>*/}
                    <form onSubmit={this.signIn}>
                        <div className='form-group'>
                            <label>Email Address</label>
                            <input className='form-control' type='text' value={user.email}  onChange={this.updateUserEmail}/>
                        </div>
                        <div className='form-group'>
                            <div className='row'>
                                <div className='col'>
                                    <label>Password</label>
                                </div>
                                <div className='col-auto'>
                                    <a className='text-muted' href='forgot-password.html'>
                                        Forgot password?
                                    </a>
                                </div>
                            </div>
                            <input className='form-control' type='password' value={user.password} onChange={this.updateUserPassword}/>
                        </div>
                        <div className='form-group text-center'>
                            <button className='btn btn-primary account-btn' type='submit'>Login</button>
                        </div>
                        <div className='account-footer'>
                            <p>Don't have an account yet? <a href='register.html'>Register</a></p>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        updateUser: userData => {
            dispatch(updateUser(userData))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Login))
